import {Section} from "../../../@types/privacyPolicySectionResources.tsx";
import {useTranslation} from "react-i18next";
import LegalPageSectionParagraph from "./LegalPageSectionParagraph.tsx";
import {getCurrentLanguageEnum} from "../../../@types/generics.tsx";

const LegalPageSection = ({section, locale}: {section: Section, locale?: string}) => {

    const {t, i18n} = locale ? useTranslation('translation', {lng: locale}) : useTranslation();

    return (
        <>
            {
                section.languageToShow.includes(getCurrentLanguageEnum(i18n.language))
                    ? <div className="opy-bg-white ">
                        <div className="container opy-block">
                            {section.heading && <h2 className="fs-6 mb-3">{t(section.heading)}</h2>}
                            {section.paragraphs.map((paragraph, index) => (
                                section.languageToShow.includes(getCurrentLanguageEnum(i18n.language))
                                    ? <LegalPageSectionParagraph key={index}
                                                                 paragraph={paragraph}
                                                                 locale={locale} />
                                    : null
                            ))}
                        </div>
                    </div>
                    : null
            }
        </>
    )
}

export default LegalPageSection;
